import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ScaleViewLoad } from '../models/ScaleViewLoad';
import { ScaleViewAddLoadResult } from '../models/ScaleViewAddLoadResult';

@Injectable({
    providedIn: 'root'
})
export class ScaleViewService {
    constructor(private _http: HttpClient) { }

    getScaleViewLoads(locCode: string, startDate: string, endDate: string, locationType: number, showAll: boolean = false): Observable<ScaleViewLoad[]> {
        return this._http.get<ScaleViewLoad[]>('api/scaleview/getscaleviewloads', {
            params: {
                locCode: locCode,
                startDate: startDate,
                endDate: endDate,
                locationType: locationType.toString(),
                showAll: showAll.toString()
            }
        });
    }

    addLoad(load: { loadId: number }): Observable<ScaleViewAddLoadResult> {
        return this._http.post<ScaleViewAddLoadResult>('api/scaleview/addload', load);
    }

    isCompuweighEnabled(locCode: string): Observable<{ isEnabled: boolean }> {
        return this._http.get<{ isEnabled: boolean }>('api/compuweigh/is-enabled', {
            params: { locCode }
        });
    }

    resolveCompuweighEnabled(defaultLocCode: string): Observable<boolean> {
        const locCode = sessionStorage.getItem('locCode') || defaultLocCode || '';
        if (!locCode || locCode.startsWith('G-')) {
            return of(false);
        }
        return this.isCompuweighEnabled(locCode).pipe(
            map(result => result.isEnabled),
            catchError(() => of(false))
        );
    }
}